"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_STATUS = exports.MODULE_GENERATION_PHASES = exports.QUEUE_NAMES = exports.COMPANY_SIZE_RANGES = exports.AI_TASK_TYPES = exports.FEEDBACK_STATUS = exports.JD_STATUS = exports.CONTRACT_TYPE_LABELS = exports.CONTRACT_TYPES = exports.WORK_TYPES = exports.LANGUAGES = exports.GRADUATE_TYPES_LABELS = exports.GRADUATE_TYPES = exports.DIRECT_REPORTS_LABELS = exports.DIRECT_REPORTS = exports.YEARS_OF_EXPERIENCE_LABELS = exports.YEARS_OF_EXPERIENCE = exports.HIRING_REQUEST_STATUS = void 0;
exports.HIRING_REQUEST_STATUS = {
    DRAFT: 'draft',
    GATHERING_CRITERIA: 'gathering_criteria',
    CRITERIA_COMPLETE: 'criteria_complete',
    JD_GENERATED: 'jd_generated',
    PENDING_FEEDBACK: 'pending_feedback',
    HIRING: 'hiring',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
};
exports.YEARS_OF_EXPERIENCE = {
    BELOW_2_YEARS: 'below_2_years',
    '2_TO_5_YEARS': '2_to_5_years',
    '6_TO_10_YEARS': '6_to_10_years',
    '10_TO_15_YEARS': '10_to_15_years',
    ABOVE_15_YEARS: 'above_15_years'
};
exports.YEARS_OF_EXPERIENCE_LABELS = {
    below_2_years: 'Below 2 years',
    '2_to_5_years': '2 - 5 years',
    '6_to_10_years': '6 - 10 years',
    '10_to_15_years': '10 - 15 years',
    above_15_years: 'Above 15 years'
};
exports.DIRECT_REPORTS = {
    INDIVIDUAL_CONTRIBUTOR: 'individual_contributor',
    '1_TO_2': '1_to_2',
    '3_TO_5': '3_to_5',
    ABOVE_5: 'above_5'
};
exports.DIRECT_REPORTS_LABELS = {
    individual_contributor: 'Individual Contributor',
    '1_to_2': '1 to 2',
    '3_to_5': '3 to 5',
    above_5: 'Above 5'
};
exports.GRADUATE_TYPES = {
    OVERSEAS_GRADUATE: 'overseas_graduate',
    TOP_UNIVERSITY_GLOBAL: 'top_university_global',
    TOP_UNIVERSITY_NATIONAL: 'top_university_national',
    OTHERS: 'others'
};
exports.GRADUATE_TYPES_LABELS = {
    overseas_graduate: 'Overseas Graduate',
    top_university_global: 'Top University Global',
    top_university_national: 'Top University National',
    others: 'Others'
};
exports.LANGUAGES = [
    'English',
    'Bahasa Indonesia',
    'Mandarin',
    'Malay',
    'Japanese',
    'Korean',
    'Thai',
    'Vietnamese',
    'Hindi',
    'French',
    'German',
    'Spanish',
    'Portuguese',
    'Arabic',
    'Dutch',
    'Italian',
    'Russian',
    'Tagalog'
];
exports.WORK_TYPES = {
    REMOTE: 'remote',
    HYBRID: 'hybrid',
    ONSITE: 'onsite'
};
exports.CONTRACT_TYPES = {
    PERMANENT: 'permanent',
    CONTRACT: 'contract',
    FREELANCE: 'freelance',
    INTERNSHIP: 'internship'
};
exports.CONTRACT_TYPE_LABELS = {
    permanent: 'Permanent',
    contract: 'Contract',
    freelance: 'Freelance',
    internship: 'Internship'
};
exports.JD_STATUS = {
    DRAFT: 'draft',
    GENERATED: 'generated',
    EDITED: 'edited',
    SENT: 'sent',
    APPROVED: 'approved'
};
exports.FEEDBACK_STATUS = {
    PENDING: 'pending',
    SUMMARIZED: 'summarized',
    INTEGRATED: 'integrated',
    DISMISSED: 'dismissed'
};
exports.AI_TASK_TYPES = {
    JD_GENERATION: 'jd_generation',
    JD_REGENERATION: 'jd_regeneration',
    FEEDBACK_SUMMARY: 'feedback_summary'
};
exports.COMPANY_SIZE_RANGES = [
    '1-10',
    '11-50',
    '51-200',
    '201-500',
    '501-1000',
    '1001-5000',
    '5000+'
];
exports.QUEUE_NAMES = {
    AI_TASKS: 'ai-tasks',
    NOTIFICATIONS: 'notifications'
};
/**
 * Module generation phases — defines the dependency-based execution order.
 * Modules within the same phase can run in parallel.
 * Each phase MUST complete before the next phase starts.
 *
 * NOTE: company_research is now generated at the Company level (not as a hiring request module).
 * It is fetched from the company_researches table during module generation.
 *
 * Dependency graph:
 *   Phase 0: deal_briefing                            (no module deps; company_research comes from Company)
 *   Phase 1: standard_jd                              (needs phase 0 + company research)
 *   Phase 2: blind_jd                                 (needs phase 1)
 *   Phase 3: candidate_sourcing, interview_questions   (needs phase 2)
 */
exports.MODULE_GENERATION_PHASES = [
    ['deal_briefing'],
    ['standard_jd'],
    ['blind_jd'],
    ['candidate_sourcing', 'interview_questions']
];
exports.MODULE_STATUS = {
    PENDING: 'pending',
    PROCESSING: 'processing',
    COMPLETED: 'completed',
    FAILED: 'failed'
};
//# sourceMappingURL=enums.js.map